module["exports"] = [
  "Blue Whale",
  "Fin Whale",
  "Sei Whale",
  "Sperm Whale",
  "Bryde’s whale",
  "Omura’s whale",
  "Humpback whale",
  "Long-Beaked Common Dolphin",
  "Short-Beaked Common Dolphin",
  "Bottlenose Dolphin",
  "Indo-Pacific Bottlenose Dolphin",
  "Northern Rightwhale Dolphin",
  "Southern Rightwhale Dolphin",
  "Tucuxi",
  "Costero",
  "Indo-Pacific Hump-backed Dolphin",
  "Chinese White Dolphin",
  "Atlantic Humpbacked Dolphin",
  "Atlantic Spotted Dolphin",
  "Clymene Dolphin",
  "Pantropical Spotted Dolphin",
  "Spinner Dolphin",
  "Striped Dolphin",
  "Rough-Toothed Dolphin",
  "Chilean Dolphin",
  "Commerson’s Dolphin",
  "Heaviside’s Dolphin",
  "Hector’s Dolphin",
  "Risso’s Dolphin",
  "Fraser’s Dolphin",
  "Atlantic White-Sided Dolphin",
  "Dusky Dolphin",
  "Hourglass Dolphin",
  "Pacific White-Sided Dolphin",
  "Peale’s Dolphin",
  "White-Beaked Dolphin",
  "Australian Snubfin Dolphin",
  "Irrawaddy Dolphin",
  "Melon-headed Whale",
  "Killer Whale (Orca)",
  "Pygmy Killer Whale",
  "False Killer Whale",
  "Long-finned Pilot Whale",
  "Short-finned Pilot Whale",
  "Guiana Dolphin",
  "Burrunan Dolphin",
  "Australian humpback Dolphin",
  "Amazon River Dolphin",
  "Chinese River Dolphin",
  "Ganges River Dolphin",
  "La Plata Dolphin",
  "Southern Bottlenose Whale",
  "Longman's Beaked Whale",
  "Arnoux's Beaked Whale"
]